
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "src/services/http-service";
import storageService from "src/services/storage-service";
import { useNavigate } from 'react-router-dom';
import Loading from "src/components/Loading";

function ConfirmationKeyLoginPage({ onSuccess }) {

    let { confirmationKey } = useParams();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState(null);

    const load = async () => {
        let form = new FormData();

        form.append('confirmationKey', confirmationKey);
        let loginResponse = await post('/login', form);

        if (loginResponse.status === 'success') {
            storageService.save(loginResponse);
            onSuccess();
            navigate("/");
        }
        else {
            setErrorMessage('Inloggningen misslyckades.');
        }
    }

    useEffect(() => {
        load();
    }, [confirmationKey]);


    if(!errorMessage){
        return <Loading />
    }

    return (
        <Box m={4}>
            <Typography variant="h6">{errorMessage}</Typography>
        </Box>

    )
}

export default ConfirmationKeyLoginPage;